'use strict';

(function () {
  'use strict';

  angular.module('msTracker').directive('msAriaPressed', [function () {
    return {
      restrict: 'A',
      scope: {
        msAriaPressed: '@'
      },
      link: function link(scope, element, attr) {
        var userAgent = window.navigator.userAgent || window.navigator.vendor;
        var isAndroid = userAgent.match(/android/i);
        scope.$watch(function () {
          return element.attr('ms-aria-pressed');
        }, function (newState) {
          return _updateAttrs(newState === 'true');
        });

        function _updateAttrs(state) {
          if (element[0].tagName === 'BUTTON') {
            if (isAndroid) {
              attr.$set('role', 'radio');
              attr.$set('aria-checked', state);
              return;
            }
            attr.$set('aria-pressed', state);
          }
        }
      }
    };
  }]);
})();